import Reveal, { Eyebrow } from "@/components/Reveal";

const steps = [
  {
    num: "01",
    tag: "Diagnóstico",
    title: "Análise da sua situação eleitoral",
    text: "Verificamos se seu título está cancelado, suspenso ou inexistente, e qual caminho se aplica ao seu caso.",
  },
  {
    num: "02",
    tag: "Prepara",
    title: "Organização do requerimento",
    text: "Orientamos exatamente quais dados e documentos você precisa reunir, revisando tudo antes do envio.",
  },
  {
    num: "03",
    tag: "Acompanhamento",
    title: "Apoio até a emissão da certidão",
    text: "Acompanhamos o andamento junto à Zona Eleitoral e te avisamos assim que a certidão estiver disponível.",
  },
];

export default function HowItWorks() {
  return (
    <section id="como-funciona" className="py-24 md:py-32" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <Eyebrow>Como funciona</Eyebrow>
          <h2 className="font-serif font-semibold text-4xl md:text-5xl tracking-tight text-ink mt-4 max-w-xl">
            Três etapas, do diagnóstico à emissão.
          </h2>
          <p className="text-ink/65 mt-5 max-w-lg text-base md:text-lg leading-relaxed">
            Um processo guiado do início ao fim — você nunca preenche nada sem
            saber exatamente o porquê.
          </p>
        </Reveal>

        <div className="mt-16 md:mt-20 grid md:grid-cols-3 gap-px bg-ink/10 border border-ink/10">
          {steps.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.12} className="bg-paper">
              <div
                className="group relative h-full p-9 md:p-11 transition-colors duration-500 hover:bg-white"
                data-testid={`step-card-${s.num}`}
              >
                <div className="flex items-baseline justify-between">
                  <span className="font-mono font-bold text-5xl md:text-6xl text-brass/85 transition-transform duration-500 group-hover:-translate-y-1">
                    {s.num}
                  </span>
                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-carimbo font-bold">
                    {s.tag}
                  </span>
                </div>
                <div className="mt-8 h-px w-full bg-ink/10 relative overflow-hidden">
                  <div className="absolute inset-y-0 left-0 w-0 bg-brass transition-[width] duration-700 group-hover:w-full" />
                </div>
                <h3 className="font-serif font-semibold text-2xl text-ink mt-7">{s.title}</h3>
                <p className="text-ink/60 text-[15px] leading-relaxed mt-4">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
